import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 25_000, // WebSocket handles real-time; polling is safety net
      refetchInterval: 30_000, // Fallback polling every 30s
      retry: 2,
      refetchOnWindowFocus: true,
    },
  },
});
